// import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../CartContext";
// import { useState } from "react";
// import { useState } from "react";

const SecondNav = ({
  loginBox,
  registerBox,
  setLoginBox,
  setRegisterBox,
  show,
  setShow,
}) => {
  const { cart } = useCart();

  const a = cart.reduce((sum, item) => sum + item.quantity, 0);
  loginBox || registerBox
    ? (document.body.style.overflow = "hidden")
    : (document.body.style.overflow = "scroll");

  return (
    <div className="flex items-center justify-between px-1 pt-[40px]">
      <ul className="uppercase grid grid-cols-5 gap-2 text-center text-[14px] font-[500]">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive
              ? "border-b-[2px] border-black"
              : "cursor-pointer pb-[10px] hover:border-b-[2px] hover:border-black transition-all duration-500 ease-in-out"
          }
        >
          Home
        </NavLink>
        <NavLink
          to="/shop"
          id="drop"
          className={({ isActive }) =>
            isActive
              ? "border-b-[2px] border-black"
              : "cursor-pointer pb-[10px] hover:border-b-[2px] hover:border-black relative transition-all duration-500 ease-in-out"
          }
        >
          Shop
        </NavLink>
        <NavLink
          to="/news"
          className={({ isActive }) =>
            isActive
              ? "border-b-[2px] border-black"
              : "cursor-pointer pb-[10px] hover:border-b-[2px] hover:border-black transition-all duration-500 ease-in-out"
          }
        >
          News
        </NavLink>
        {/* <NavLink
          to="/about"
          className={({ isActive }) =>
            isActive
              ? "border-b-[2px] border-black"
              : "cursor-pointer pb-[10px] hover:border-b-[2px] hover:border-black transition-all duration-500 ease-in-out"
          }
        >
          About Us
        </NavLink> */}
        <NavLink
          to="/contact"
          className={({ isActive }) =>
            isActive
              ? "border-b-[2px] border-black"
              : "cursor-pointer pb-[10px] hover:border-b-[2px] hover:border-black transition-all duration-500 ease-in-out"
          }
        >
          Contact Us
        </NavLink>
      </ul>
      <div className="grid grid-cols-2 gap-5">
        <button
          onClick={() => setLoginBox(true)}
          className="hover:text-amber-500"
        >
          <i className="fa-regular fa-user"></i> LOGIN
        </button>
        <NavLink to="/cart-page" className="hover:text-amber-500 relative">
          <i className="fa-solid fa-bag-shopping text-[22px]"></i> $
          {cart.reduce((sum, item) => sum + item.price, 0).toFixed(2)}
          <p className="absolute top-[-20px] left-[5px] bg-black text-white h-[5px] w-[5px] flex items-center justify-center p-[10px] text-[12px] rounded-full hover:bg-amber-500">
            {a}
          </p>
        </NavLink>
      </div>

      {/* login */}
    </div>
  );
};

export default SecondNav;
